// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header styling */
.leaderboard-header {
  padding-left: 0.5rem;
}

.leaderboard-title {
  font-size: 16px;
  font-weight: 600;
  color: #0066CC;
  margin-bottom: 0.25rem;
}

.leaderboard-description {
  font-size: 0.9rem;
  color: #5f6b7a;
  margin: 0;
}

/* Outer container */
.leaderboard-table-container {
  width: 1632px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 12px;
}

/* Table wrapper */
.leaderboard-table-wrapper {
  width: 100%;
  max-height: 414px;
  overflow-y: auto;
}

/* Table styling */
.unl-table {
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
  border-left: none;
  border-right: none;
  font-size: 14px;
}

.unl-table thead th {
  background-color: #EBF2FE;
  color: #303030;
  font-weight: 400;
  font-size: 14px;
  padding: 12px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  height: 64px;
  vertical-align: middle;
}


.unl-table tbody td {
  padding: 12px;
  vertical-align: middle;
  border-top: 1px solid #e0e0e0;
}

.unl-table tbody tr {
  height: 60px; /* ✅ fixed row height */
}

.unl-table tbody tr:hover {
  background-color: #f0f6ff;
}

/* Custom pagination bar */
.custom-pagination {
  width: 100%;
  height: 50px; /* ✅ fixed height */
  background: #EBF2FE;
  border: 1px solid #F0F6FF;
  border-radius: 4px;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  box-sizing: border-box;
}



.custom-pagination .page-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.custom-pagination .page-controls button {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

.custom-pagination .page-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.custom-pagination .rows-selector {
  display: flex;
  align-items: center;
  gap: 4px;
}

.custom-pagination select {
  padding: 2px 6px;
  font-size: 14px;
}

.custom-pagination .total-text {
  color: #71717A; /* Label color */
  font-size: 15px; /* Label size */
}

.custom-pagination .total-text span {
  color: #111111;
  font-size: 15px;
}

.unl-table tbody td {
  font-size: 14px;
  color: #303030;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Leaderboard.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,YAAY,EAAE,uBAAuB;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY,EAAE,mBAAmB;EACjC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,gBAAgB;EAChC,eAAe,EAAE,eAAe;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* Header styling */\n.leaderboard-header {\n  padding-left: 0.5rem;\n}\n\n.leaderboard-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #0066CC;\n  margin-bottom: 0.25rem;\n}\n\n.leaderboard-description {\n  font-size: 0.9rem;\n  color: #5f6b7a;\n  margin: 0;\n}\n\n/* Outer container */\n.leaderboard-table-container {\n  width: 1632px;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  padding: 12px;\n}\n\n/* Table wrapper */\n.leaderboard-table-wrapper {\n  width: 100%;\n  max-height: 414px;\n  overflow-y: auto;\n}\n\n/* Table styling */\n.unl-table {\n  background-color: #fff;\n  border-bottom: 1px solid #e0e0e0;\n  border-left: none;\n  border-right: none;\n  font-size: 14px;\n}\n\n.unl-table thead th {\n  background-color: #EBF2FE;\n  color: #303030;\n  font-weight: 400;\n  font-size: 14px;\n  padding: 12px;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom: none;\n  height: 64px;\n  vertical-align: middle;\n}\n\n\n.unl-table tbody td {\n  padding: 12px;\n  vertical-align: middle;\n  border-top: 1px solid #e0e0e0;\n}\n\n.unl-table tbody tr {\n  height: 60px; /* ✅ fixed row height */\n}\n\n.unl-table tbody tr:hover {\n  background-color: #f0f6ff;\n}\n\n/* Custom pagination bar */\n.custom-pagination {\n  width: 100%;\n  height: 50px; /* ✅ fixed height */\n  background: #EBF2FE;\n  border: 1px solid #F0F6FF;\n  border-radius: 4px;\n  padding: 8px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n\n\n.custom-pagination .page-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.custom-pagination .page-controls button {\n  background: none;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.custom-pagination .page-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.custom-pagination .rows-selector {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.custom-pagination select {\n  padding: 2px 6px;\n  font-size: 14px;\n}\n\n.custom-pagination .total-text {\n  color: #71717A; /* Label color */\n  font-size: 15px; /* Label size */\n}\n\n.custom-pagination .total-text span {\n  color: #111111;\n  font-size: 15px;\n}\n\n.unl-table tbody td {\n  font-size: 14px;\n  color: #303030;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
